var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIbk46(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1322 2.54966C10.9982 3.11588 10.1535 4.09005 9.75423 5.29269L2.16233 28.1094C1.76006 29.3082 1.85418 30.5985 2.42495 31.7374C2.9923 32.8634 3.96723 33.7104 5.16569 34.1112L30.0628 42.47C31.27 42.8708 32.5588 42.7793 33.6912 42.2108C34.8248 41.6382 35.6714 40.6693 36.0657 39.4632L43.661 16.6534C44.4925 14.1688 43.1404 11.4728 40.6558 10.6452L15.761 2.28857C14.5515 1.88971 13.2711 1.97662 12.1322 2.54966Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5991 29.0297H14.3148V17.1772H12.5991V29.0297ZM24.3022 24.4624C22.95 25.9713 21.2639 27.1887 19.3095 27.9436L18.1858 28.3788V17.8075L19.2958 18.2375C21.2529 18.9847 22.9432 20.2025 24.3022 21.7042C25.2695 20.1475 25.8703 18.3414 25.9936 16.3772C26.301 11.3093 23.1269 6.65892 18.7668 5.04036L15.1699 3.84341C13.5468 3.30263 11.8189 4.19787 11.2834 5.81643L3.66991 28.646C3.12913 30.271 4.03993 32.0338 5.66495 32.5681L22.9432 38.3369C24.7048 36.4637 25.8475 33.9818 26.0145 31.2133C26.1671 28.7432 25.523 26.4142 24.3022 24.4624Z",
    fill: "#198FCA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3055 23.0833C22.3408 21.9524 21.1746 21.0022 19.8281 20.3062V25.8772C21.1746 25.1797 22.3472 24.218 23.3055 23.0833Z",
    fill: "#E95705"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9028 28.9921L33.7609 28.9982L29.3545 23.0708L33.8304 17.1452L35.9909 17.1369L31.5048 23.0795L35.9028 28.9921ZM40.1033 12.1681L24.2471 6.86914C26.3768 9.20041 27.68 12.2979 27.6861 15.6902C27.6895 18.3718 26.8535 20.9368 25.3985 23.0837C26.8588 25.224 27.6998 27.7872 27.707 30.4687C27.7081 33.6717 26.5571 36.6227 24.6406 38.9077L30.5953 40.8951C32.2238 41.4367 33.9429 40.5414 34.4845 38.9179L42.1018 16.0906C42.6411 14.4682 41.7295 12.707 40.1033 12.1681Z",
    fill: "#015198"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbk46);
export default __webpack_public_path__ + "static/media/IBK투자증권-46.1d67d5d7d22442300d4287d4ad93a1a7.svg";
export { ForwardRef as ReactComponent };